import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function ArrowRight({ className }: Props) {
  return (
    <IconBase name="arrow-right" w={24} className={className}>
      <line x1="4" y1="11.5" x2="20" y2="11.5" strokeWidth="2" fill="none"/>
      <path d="M12.5 4L20 11.5L12.5 19" strokeWidth="2" fill="none"/>
    </IconBase>
  )
}

export default ArrowRight
